import { useAuth } from 'context/auth-context';
import dayjs from 'dayjs';
import { useSessionGymLocalDateTime } from 'hooks/gym/useGym';

export interface AssignGate {
  canMutate: boolean;
  todayInGym: string;
}

export default function useAssignGate(): AssignGate {
  const { hasPerm } = useAuth();
  const canMutate = hasPerm('WorkoutMutate');
  const gymNow = useSessionGymLocalDateTime();
  const todayInGym = (gymNow ?? dayjs()).format('YYYY-MM-DD');

  return { canMutate, todayInGym };
}
